import { render, staticRenderFns } from "./MoThirdpartLogin.vue?vue&type=template&id=10294593&scoped=true&"
import script from "./MoThirdpartLogin.vue?vue&type=script&lang=js&"
export * from "./MoThirdpartLogin.vue?vue&type=script&lang=js&"
import style0 from "./MoThirdpartLogin.vue?vue&type=style&index=0&id=10294593&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10294593",
  null
  
)

export default component.exports